<template>
    <div class="still" v-bind:style="{ background: kioskBackground }">
        <div class="nav">
          <div class="logo"><img src="/assets/images/logo-navbar.svg"></div>
            <div class="button-close" @click="goBack"><img :src="'/assets/buttons/button-close.svg'"></div>
        </div>
        <div class="container-credits" v-if="stillData.title !== ''">
            <div class="title-credits" v-bind:style="{ background: kioskBackground + '66'}">{{ stillData.title }}</div>
<!--            <div class="creator-credits" v-bind:style="{ background: kioskBackground + '66'}">{{ stillData.creator }}</div>-->
        </div>
        <div class="container-media">
            <img :src="stillData.still_url" alt="image">
        </div>
        <!-- kiosk: {{ kioskId }} - {{ langId }} - {{ themeId }} - {{ themePage }} - {{ itemId }} {{ stillId }} -->
    </div>
</template>

<script>
import config from '../config/config.json';
import router from '../router';
import axios from 'axios';
// import kiosks from '@/content/kiosks.json';

export default {
    name: 'Still',
    props: ['langId', 'itemId', 'stillId', 'spotId'],
    data() {
        return {
            configData: config,
            kioskTitle: '',
            themeTitle: '',
            kioskCode: '',
            kioskBackground: '',
            stillData: {
                "still_url": '/assets/spinners/spinner-600-transparant.gif',
                "title": '',
                "creator": ''
            }
        }
    },
    methods: {
        goBack() {
            router.push('/item/' + this.spotId + '/' + this.itemId + '/' + this.langId);
        }
    },
    created() {
        const axiosQuery = this.configData.api + 'media/' + this.stillId  + '?@key_identity=' + this.configData.key_identity + '&@key_credential=' + this.configData.key_credential;
        axios.get(axiosQuery)
        .then((res) => {
            this.stillData.still_url = res.data.thumbnail_display_urls.medium;
            if(res.data["dcterms:title"]) {
                res.data["dcterms:title"].forEach((stillTitle) => {
                    if(stillTitle["@language"] && stillTitle["@language"] === this.langId) {
                        this.stillData.title = stillTitle["@value"];
                    }
                });
            }
        })
        .catch();
    }
}
</script>

<style>
.still {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    font-family: Avenir, Helvetica, Arial, sans-serif;
}
.container-media {
    margin-top: 80px;
    width: 100%;
    height: fit-content;
    display: flex;
}
.container-media img {
    object-fit: contain;
    /* max-width: 100%; */
    /* max-height: 100%; */
    width: 100%;
    height: auto;
    margin-left: auto;
    margin-right: auto;
}
.container-credits {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 45px;
    color: white;
     background-color: #ffffff66;
}
.title-credits {
    font-weight: bold;
    width: 100%;
    text-align: center;
    margin-top: 4px;
    text-shadow: 1px 1px 1px #00000066;
}
.creator-credits {
    font-weight: bold;
    width: 100%;
    text-align: center;
}
@media only screen and (min-width: 768px) {
    .container-media {
        position: absolute;
        top: 0;
        left: 0;
        /* margin-top: 80px; */
        width: 100%;
        height: 100%;
        display: contents;
    }
    .container-media img {
        object-fit: contain;
        max-width: 100%;
        max-height: 100%;
        /* width: 100%; */
        height: auto;
        margin-left: auto;
        margin-right: auto;
    }
}
</style>
